module.exports = __webpack_public_path__ + "b86ca799a594970f379cdde8d13109c7.png";